<a tabindex="0" href="#main-content" class="skip-link">Skip to main content</a>
<header
  #headerRef
  class="header"
  [class.hidden]="isHeaderHidden()"
  [appStoryblok]="_editable()"
>
  <rds-header
    (logoTriggered)="onLogoTriggered()"
    [inexpNavigation]=""
  >
    <rds-divider rds-header-start-divider></rds-divider>
    <rds-header-app-name class="rds-link" [attr.aria-label]="appTitle()"
      (click)="onLogoTriggered()">
      {{ appTitle() }}
    </rds-header-app-name>

    <rds-header-navigation-primary>
      <nav class="header-menu" aria-label="primary navigation">
        @for (item of navigation(); track item) {
          <rds-header-link
            class="ui-label-m-bold"
            [active]="true"
            [routerLink]="item.link"
            [inexpNavigation]="item.link"
            [attr.aria-label]="item.title"
            role="link"
          >
            {{ item.title }}
          </rds-header-link>
        }

        <!-- Form manager lives in FILM, a separate application, so this is a
             real anchor rather than a `routerLink`: the router would look for a
             route this app does not have and swallow the click. Same href and
             same flag as the entry in the Focus sidebar.
             The events stop here because two ancestors cancel them and a plain
             anchor has nothing else to navigate it: `inexpNavigation` on
             <rds-header> cancels every click and Enter, target or not, and
             <rds-header-link> cancels Enter on keydown. Fixing only one leaves
             the link dead to the keyboard. (A Faro user-action attribute added
             here would therefore see pointer use but not Enter.)
             The wrapper is taken out of the tab order so keyboard users land
             on the anchor, not on an unnamed stop in front of it. -->
        <rds-header-link
          *inexpFeatureFlag="'focus_inexp_2522_form_manager'"
          class="ui-label-m-bold"
          [active]="true"
          [tabIndex]="-1"
        >
          <a
            class="header-menu-external"
            href="/film/form-manager"
            (click)="$event.stopPropagation()"
            (keydown.enter)="$event.stopPropagation()"
          >
            Form manager
          </a>
        </rds-header-link>
      </nav>
    </rds-header-navigation-primary>

    <rds-divider rds-header-end-divider></rds-divider>
    <rds-header-actions>
      <button
        *inexpFeatureFlag="'panorama_inexp_2498_assistant'"
        rds-text-button
        size="m"
        class="assistant-link"
        routerLink="/assistant"
        aria-label="Open Panorama AI"
      >
        <rds-icon namespace="outlined" icon="chat_recommendation" />
        Panorama AI
      </button>

      @if (showNotifications()) {
        <button rds-icon-button size="m" aria-label="notifications">
          <rds-icon
            class="action"
            namespace="outlined"
            icon="notification"
          ></rds-icon>
        </button>
      }

      <rds-avatar
        class="user-avatar"
        aria-label="user profile"
        role="button"
        [rdsMenuTriggerFor]="profileMenu"
        (keydown.enter)="handleProfileMenu()"
      >
        <span rds-avatar-initials>{{ initials() }}</span>
      </rds-avatar>

      <rds-menu #profileMenu>
        <button rds-menu-item (click)="logout()">
          <rds-icon namespace="outlined" icon="logoff" />
          Logout
        </button>
      </rds-menu>

      @if (showFeedbackButton()) {
        <button rds-primary-button size="m" class="feedback-button">
          {{ feedbackButtonTitle() }}
        </button>
      }
    </rds-header-actions>
  </rds-header>

  @if (showSearch()) {
    <div class="header-search-bar bg-50-shade-blue">
      <rds-search includeButton size="l" class="search-input"></rds-search>
    </div>
  }
  @if (showSecondaryNavigation()) {
    <nav class="header-secondary-navigation" aria-label="secondary navigation">
      @for (
        navSection of secondaryNavigation();
        track navSection;
        let idx = $index
      ) {
        <button
          rds-text-button
          class="me-8 c-black"
          (click)="toggleMegaMenu(navSection)"
          [class.active]="activeMenu() === navSection"
          [attr.aria-expanded]="activeMenu() === navSection">
          <span>{{ navSection.title }}</span>
          <rds-icon namespace="filled" [icon]="activeMenu() === navSection ? 'chevron_up' : 'chevron_down'"/>
        </button>
      }
    </nav>
  }
  @if (activeMenu()) {
    <inexp-mega-menu
      [menuCategories]="activeMenuData()"
      [menuSection]="activeMenu()"
      [isLoading]="activeMenuLoading()"
      (closed)="closeMegaMenu()"
    >
    </inexp-mega-menu>
  }
</header>

<div class="header-spacer" [style.height.px]="offsetHeight()"></div>
